import { createRouter, createWebHistory } from 'vue-router';
import UserRegistration from './components/UserRegistration.vue';
import UserList from './components/UserList.vue';
import UserDetails from './components/UserDetails.vue';
import MediaUpload from './components/MediaUpload.vue';

// import ExperimentSetup from './components/ExperimentSetup.vue';
// import ResultsDashboard from './components/ResultsDashboard.vue';



const routes = [
  { path: '/', redirect: '/register' },
  { path: '/register', component: UserRegistration },
  { path: '/users', component: UserList },
//   { path: '/user/:pin', component: UserDetails, props: true }, 
  { path: '/user/:pin', component: UserDetails, props: route => ({ pin: route.params.pin }) },
  { path: '/media-upload', component: MediaUpload },


  // { path: '/setup', component: ExperimentSetup },
  // { path: '/results', component: ResultsDashboard },
];


const router = createRouter({
    history: createWebHistory(),
    routes,
  });
  
  router.beforeEach((to, from, next) => {
    console.log('Debug: Navigating to:', to.fullPath);
    next();
});
  
  export default router;
